module.exports = "/assets/about/success/bank.jpg?bwIcLL6";